import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import eventApi from '_api/event'

const useShareLinkEvent = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { addToast } = useToasts()

  const handleShare = async (eventId, onSuccess) => {
    if (!eventId) {
      addToast('Event information is missing', { appearance: 'error', autoDismiss: true })
      return
    }

    setIsLoading(true)
    try {
      const response = await eventApi.createSharedEvent({ eid: eventId })
      const sharedId = response?.msgCode === 75000 ? response?.msgResp : null

      if (sharedId) {
        const url = `${process.env.REACT_APP_APP_URL}/event/detail-shared?eid=${eventId}&sharedId=${sharedId}`
        if (onSuccess) {
          onSuccess(url)
        }
      } else {
        addToast('Failed to create share link', { appearance: 'error', autoDismiss: true })
      }
    } catch (error) {
      addToast(error?.msgResp || 'Failed to create share link', {
        appearance: 'error',
        autoDismiss: true,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return { handleShare, isLoading }
}

export default useShareLinkEvent
